































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringTransportEksternalForm from "./MonitoringTransportEksternalForm.vue";
import { storeMonitoringTransportEksternal } from "@/store/modules/MonitoringTransportEksternalStore";
import MonitoringTransportEksternalSvc from "@/services/MonitoringTransportEksternalService";
import { appModule } from "@/store/modules/app";
import moment from "moment";

@Component({
  components: {
    MonitoringTransportEksternalForm,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class MonitoringTransportEksternalList extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  showForm = false;
  showDetail = false;
  editData: any = null;

  tableHeaders = [
    { text: "Tanggal", value: "tanggal", width: "120px" },
    { text: "Jam", value: "jam", width: "80px" },
    { text: "Tujuan", value: "faskes_tujuan" },
    { text: "Petugas", value: "petugas", sortable: false },
    { text: "Aksi", value: "actions", sortable: false, width: "150px" },
  ];

  mounted() {
    storeMonitoringTransportEksternal.getByRegister(this.register);
  }

  get storeMonitoring() {
    return storeMonitoringTransportEksternal;
  }

  get items() {
    return storeMonitoringTransportEksternal.items;
  }

  formatDate(date: string) {
    return date ? moment(date).format("DD-MM-YYYY") : "-";
  }

  tambah() {
    this.editData = null;
    this.showDetail = false;
    this.showForm = true;
  }

  edit(item: any) {
    this.editData = item;
    this.showDetail = false;
    this.showForm = true;
  }

  lihat(item: any) {
    this.editData = item;
    this.showForm = false;
    this.showDetail = true;
  }

  cancelForm() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
  }

  onSaved() {
    this.showForm = false;
    this.showDetail = false;
    this.editData = null;
    storeMonitoringTransportEksternal.getByRegister(this.register);
  }

  cetakPdf(item: any) {
    MonitoringTransportEksternalSvc.printPdf(item.id);
  }

  async hapus(item: any) {
    const q = confirm("Anda yakin akan menghapus monitoring transport ini?");
    if (q) {
      try {
        const resp = await MonitoringTransportEksternalSvc.destroy(item.id);
        if (resp?.data?.status == "1") {
          appModule.NoticeDelay("Berhasil menghapus");
          storeMonitoringTransportEksternal.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
